import { stateFactoryKey, type StateFactory } from '@/injectionKeys';
import { getCurrentJstCalendarDate, formatYearMonth, formatHyphenatedDate } from '@/utils/date';
import { CALENDAR_LIST } from '@/utils/state';

export interface DatePickerCalendar {
  isFirstWeek: boolean;
  yearMonthLabel: string;
  day: string;
  isCurrentMonth: boolean;
  isDisabled: boolean;
}

export const GenerateCalendarMonths = 18;

/**
 * 当月から18ヶ月分のカレンダー表示用の配列を生成する
 * @returns カレンダー表示用の配列 CalendarDay[][]
 */
export const getCalendarRowList = (): DatePickerCalendar[][] => {
  // 暦日演算は UTC モードで行い、実行環境のTZ・DSTの影響を排除する（getCurrentJstCalendarDate 参照）
  const currentDate = getCurrentJstCalendarDate().startOf('day');
  // 7日ごとに配列を分割したカレンダー表示用の配列
  const calendarRowList: DatePickerCalendar[][] = [];

  for (let i = 0; i < GenerateCalendarMonths; i++) {
    const startDate = currentDate.add(i, 'month').startOf('month');
    const endDate = currentDate.add(i, 'month').endOf('month');

    const calendarDayList: DatePickerCalendar[] = [];
    let yearMonthLabel = '';
    for (let day = startDate; day <= endDate; day = day.add(1, 'day')) {
      const isFirstWeek = day.week() === startDate.week();
      if (isFirstWeek) {
        yearMonthLabel = formatYearMonth(day, 'en');
      }
      calendarDayList.push({ day: formatHyphenatedDate(day), isFirstWeek, yearMonthLabel, isCurrentMonth: true, isDisabled: day.isBefore(currentDate) });
    }
    // カレンダー表示が揃うように、前の月の日付を追加
    for (let day = startDate.add(-1, 'day'); day.day() !== 6; day = day.add(-1, 'day')) {
      calendarDayList.unshift({ day: formatHyphenatedDate(day), isFirstWeek: true, yearMonthLabel, isCurrentMonth: false, isDisabled: true });
    }

    for (let i = 0; i < calendarDayList.length; i += 7) {
      calendarRowList.push(calendarDayList.slice(i, i + 7));
    }
  }

  return calendarRowList;
};

/**
 * カレンダー表示用の Composable
 */
export const useDatePickerCalendar = () => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const calendarRowListState = stateFactory.create<DatePickerCalendar[][]>(CALENDAR_LIST, []);

  if (calendarRowListState.value.length === 0) {
    calendarRowListState.value = getCalendarRowList();
  }

  return { calendarRowListState };
};
